import { Decoration_Type } from "./../../ricos-types/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isSpoilerInText = TiptapContentResolver.create(
  (content, { getEditorQuery }, _editor) => {
    const editorQuery = getEditorQuery();
    const decorations = editorQuery.query.activeDecorationsByType(Decoration_Type.SPOILER);
    return decorations.length > 0 && decorations.every((item) => item?.type === Decoration_Type.SPOILER);
  }
);
export {
  isSpoilerInText
};
//# sourceMappingURL=is-spoiler-in-text.js.map
